import API from '../apiCreate'
import { getParams } from '../getParams'
import type {
  RequestCrmLeadContractCreateFromTemplate,
  RequestCrmLeadContractSendForSignature,
  RequestCrmLeadContractUpdate,
  ResponseCrmLeadContract,
  ResponseCrmLeadContractHistory,
  ResponseCrmLeadContracts,
} from '../types/crm/crmLeadContract.types'
import type { EmptyResponse } from '../types/base.types'

/** Договоры карточки лида: `/v1/crm-lead-contract/*` (не user/contract). */
export const crmLeadContractApi = {
  /** GET index?lead_id= — объединённый список лид ∪ ученик. */
  getIndex: (params: { lead_id: number }) =>
    API.get<ResponseCrmLeadContracts>(
      `crm-lead-contract/index${getParams(params)}`,
    ),

  /** POST upload multipart: lead_id, name, file */
  upload: (formData: FormData) =>
    API.post<ResponseCrmLeadContract>('crm-lead-contract/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  /** POST create-from-template */
  createFromTemplate: (data: RequestCrmLeadContractCreateFromTemplate) =>
    API.post<ResponseCrmLeadContract>(
      'crm-lead-contract/create-from-template',
      data,
    ),

  /** PUT/PATCH update?lead_id=&id= */
  update: (
    params: { lead_id: number; id: number },
    data: RequestCrmLeadContractUpdate,
  ) =>
    API.put<ResponseCrmLeadContract>(
      `crm-lead-contract/update${getParams(params)}`,
      data,
    ),

  /** POST toggle-processed?lead_id=&id= */
  toggleProcessed: (params: { lead_id: number; id: number }) =>
    API.post<ResponseCrmLeadContract>(
      `crm-lead-contract/toggle-processed${getParams(params)}`,
      {},
    ),

  /** GET history?lead_id=&id= */
  getHistory: (params: { lead_id: number; id: number }) =>
    API.get<ResponseCrmLeadContractHistory>(
      `crm-lead-contract/history${getParams(params)}`,
    ),

  /** POST send-for-signature?lead_id=&id= */
  sendForSignature: (
    params: { lead_id: number; id: number },
    data: RequestCrmLeadContractSendForSignature,
  ) =>
    API.post<ResponseCrmLeadContract>(
      `crm-lead-contract/send-for-signature${getParams(params)}`,
      data,
    ),

  /** DELETE delete?lead_id=&id= */
  delete: (params: { lead_id: number; id: number }) =>
    API.delete<EmptyResponse>(
      `crm-lead-contract/delete${getParams(params)}`,
    ),
}
